import * as Yup from 'yup';

const PAYMENT_FORM_SCHEMA = Yup.object().shape({
	plan_type: Yup.number()
		.nullable()
		.transform((value, originalValue) => {
			return originalValue.trim?.() === '' ? null : value;
		})
		.required('Plan Type is required'),
	first_name: Yup.string().required('First Name is required'),
	last_name: Yup.string().required('last Name is required'),
	email: Yup.string().email('Invalid email').required('Email is required'),
	save_card_information: Yup.boolean()
});

export default PAYMENT_FORM_SCHEMA;
